module.exports = __webpack_public_path__ + "static/img/dress.cdefffc0.gif";